import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CreatePageRoutingModule } from './create-routing.module';

import { CreatePage } from './create.page';
import { LinkPickerComponent } from './link-picker/link-picker.component';

import {PickListModule} from 'primeng/picklist';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete'; 
import { EditorModule } from '@tinymce/tinymce-angular';
import { QuillModule } from 'ngx-quill';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CalendarModule } from 'primeng/calendar';
import { DescriptionDropdownModule } from 'src/app/components/description-dropdown/description-dropdown.module';
import { MemberPickerModule } from 'src/app/components/team-members/member-picker/member-picker.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CreatePageRoutingModule,
    PickListModule,
    GooglePlaceModule,
    EditorModule,
    QuillModule,
    PipesModule,
    CalendarModule,
    MemberPickerModule,
    DescriptionDropdownModule
  ],
  declarations: [CreatePage, LinkPickerComponent]
})
export class CreatePageModule {}
